import { useRef } from 'react';
import { jsx } from '@emotion/core';
import useDocumentsAppConfigs from "../../../hooks/useDocumentsAppConfigs.js";
import { observer } from 'mobx-react';
import _css from '@emotion/css';
import classnames from 'classnames';
import useStores from "../../../hooks/useStores.js";

var FillableCheckboxField = function FillableCheckboxField(_ref) {
  var selected = _ref.selected,
      field = _ref.field,
      disabled = _ref.disabled,
      onFocus = _ref.onFocus,
      modifyingFieldPropertiesEnabled = _ref.modifyingFieldPropertiesEnabled;
  var data = field.data;
  var checked = !!data.value;
  var bounding = useRef(null);

  var _useDocumentsAppConfi = useDocumentsAppConfigs(),
      currentUserId = _useDocumentsAppConfi.currentUserId,
      currentUserPermissions = _useDocumentsAppConfi.currentUserPermissions;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  var x = field.x,
      y = field.y,
      width = field.width,
      height = field.height;
  var highlightUnassignedFields = pdfStore.highlightUnassignedFields;
  var isAssignedToCurrentUser = field.belongsTo(currentUserId, currentUserPermissions);
  var isUnassignedField = !data.parties.length;
  var fieldHasPreexistingValue = checked && !field.valueWasModified;
  disabled = disabled || pdfStore.signableOnly || fieldHasPreexistingValue && pdfStore.fieldsWithPriorValuesDisabled;
  var bgColor = 'bg-transparent';
  var borderColor = '';

  if (!disabled) {
    if (highlightUnassignedFields) {
      bgColor = isAssignedToCurrentUser ? 'bg-primary' : 'bg-info';

      if (isAssignedToCurrentUser) {
        borderColor = 'border-primary';
      } else if (isUnassignedField) {
        borderColor = 'border-warning';
      } else {
        borderColor = 'border-info';
      }
    } else {
      bgColor = isAssignedToCurrentUser ? 'bg-primary' : 'bg-transparent';
      borderColor = isAssignedToCurrentUser ? 'border-primary' : '';
    }
  }

  var fillable = !disabled && isAssignedToCurrentUser;

  var toggleChecked = function toggleChecked() {
    if (fillable) {
      field.updateData({
        value: !checked
      });
      field.setValueWasModified(true);
    }
  };

  var handleFocus = function handleFocus(e) {
    if (fillable || modifyingFieldPropertiesEnabled) {
      onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    }
  };

  return jsx("g", null, jsx("rect", {
    x: x,
    y: y,
    width: width,
    height: height,
    className: "".concat(bgColor, " ").concat(selected || isUnassignedField ? borderColor : ''),
    fillOpacity: bgColor === 'bg-info' ? 0.75 : 0.25
  }), jsx("foreignObject", {
    x: x,
    y: y,
    width: width,
    height: height
  }, jsx("div", {
    id: "fillable-field-anchor-".concat(field.id),
    tabIndex: 0,
    role: "checkbox",
    ref: bounding,
    className: classnames(['form-control', 'shadow-none', 'bg-transparent', 'border-0', 'd-flex align-items-center justify-content-center']),
    style: {
      width: width,
      height: height,
      padding: 1
    },
    onMouseDown: toggleChecked,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === ' ') {
        // space key
        e.preventDefault();
        toggleChecked();
      }
    },
    onFocus: handleFocus,
    "data-testid": "checkbox",
    css: /*#__PURE__*/_css({
      cursor: fillable || modifyingFieldPropertiesEnabled ? 'pointer' : ''
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    "aria-checked": checked
  }, checked && jsx("div", {
    className: "fa fa-solid fa-times",
    "data-testid": "checked-checkbox",
    style: {
      fontSize: Math.min(height, width)
    }
  }))));
};

FillableCheckboxField.displayName = "FillableCheckboxField";
var FillableCheckboxField$1 = observer(FillableCheckboxField);
export default FillableCheckboxField$1;